import React from 'react'
import { Icon } from 'routes/components/Shared'

export const PricingPlansCard = ({ card }) => {
  const { title, subtitle, icon } = card

  return (
    <div className='flex-column plans-card'>
      <h2 className='page__title plans-card__title'>
        {icon && <Icon className='plans-card__icon' type={icon} />}

        {title}
      </h2>

      <p className='page__subtitle plans-card__subtitle'>{subtitle}</p>
    </div>
  )
}
